import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { Separator } from 'src/components/ui/separator';
import { IncludeSubjectField } from 'src/components/Integrations/IntegrationForms/IntegrationFormFields/IncludeSubjectField/IncludeSubjectField';
import { AIAssistantModeFiled } from 'src/components/Integrations/IntegrationForms/IntegrationFormFields/AIAssistantModeField/AIAssistantModeFiled';
import { IncludeTicketFields } from 'src/components/Integrations/IntegrationForms/IntegrationFormFields/IncludeTicketFields/IncludeTicketFields';
import type { Project } from 'src/services/projectsService';
import { splitAutocloseWindow } from 'src/utils/autocloseWindow';

export const EditZendeskEmailAdvancedSettings = ({
  currentProject,
}: {
  currentProject?: Project;
}) => {
  const { control, watch, resetField, clearErrors } = useFormContext();
  const isAutocloseEnabled = watch('autocloseEnabled');
  const { autocloseHours, autocloseMinutes } = splitAutocloseWindow(
    currentProject?.autoclose_time_window_minutes,
  );

  useEffect(() => {
    resetField('autocloseHours', {
      defaultValue:
        isAutocloseEnabled && currentProject?.autoclose_time_window_minutes ? autocloseHours : 0,
    });
    resetField('autocloseMinutes', {
      defaultValue:
        isAutocloseEnabled && currentProject?.autoclose_time_window_minutes ? autocloseMinutes : 0,
    });
  }, [isAutocloseEnabled]);

  return (
    <div className={'w-full flex flex-col gap-2.5 p-2.5 bg-[#A498FF1A] rounded-sm-5'}>
      <IncludeSubjectField control={control} />
      <Separator className={'bg-[#E3E6E8]'} />
      <AIAssistantModeFiled control={control} />
      <Separator className={'bg-[#E3E6E8]'} />
      <IncludeTicketFields
        control={control}
        watch={watch}
        clearErrors={clearErrors}
        inputFieldType={'number'}
        disabled={true}
      />
    </div>
  );
};
